import axios from 'axios';

// Crée une instance Axios qui ajoute automatiquement le token JWT
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Intercepter les requêtes et ajouter le token JWT
api.interceptors.request.use((config) => {
    // Utiliser 'access_token' pour être cohérent avec le reste de l'application
    const token = localStorage.getItem('access_token') || localStorage.getItem('token');
    if (token) {
        // Assurer que le token n'a pas de guillemets qui pourraient causer des problèmes
        const cleanToken = token.replace(/^"|"$/g, '');
        console.log("Sending request with token:", cleanToken);
        
        // Utiliser l'en-tête Authorization standard pour JWT
        config.headers['Authorization'] = `Bearer ${cleanToken}`;
        
        // Conserver aussi l'ancien format pour la rétrocompatibilité
        config.headers['Token'] = cleanToken;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        console.log("API Error:", error.response);
        if (error.response && error.response.status === 401) {
            // Supprimer les deux formats de token
            localStorage.removeItem('token');
            localStorage.removeItem('access_token');
            window.location.href = '/login';  // Redirect to login page
        }
        return Promise.reject(error);
    }
);

// Fonction utilitaire pour l'accès aux images avec gestion du token
api.getImageUrl = (path) => {
    if (!path) return '';
    
    const token = localStorage.getItem('access_token') || localStorage.getItem('token');
    if (!token) return path;
    
    const cleanToken = token.replace(/^"|"$/g, '');
    const separator = path.includes('?') ? '&' : '?';
    return `${path}${separator}token=${cleanToken}`;
};

export default api;
